import React from 'react';
import * as Lucide from 'lucide-react';

// Small circle with orange stroke and lucide icon inside
const OrangeIcon = ({ name, size = 44, iconSize = 22, className = '' }) => {
  const Icon = Lucide[name] || Lucide.Circle;
  return (
    <div
      className={`inline-flex items-center justify-center rounded-full border-2 border-[#F5901F] text-[#F5901F] bg-transparent shrink-0 ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <Icon size={iconSize} strokeWidth={2} />
    </div>
  );
};

export default OrangeIcon;
